import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, Settings as SettingsIcon } from 'lucide-react';

import { logout } from '../api/auth';
import BigButton from '../components/BigButton';
import PageHeader from '../components/PageHeader.jsx';
import { useAuthStore } from '../store/auth';

/**
 * Phase A minimal settings page — exists to provide a logout / forget-this-
 * device entry point. Real settings (notifications, language, profile fields,
 * etc.) come in a later phase.
 */
export default function Settings() {
  const navigate = useNavigate();
  const user = useAuthStore((s) => s.user);
  const [loading, setLoading] = useState(false);

  async function onLogout() {
    setLoading(true);
    try {
      await logout();
    } finally {
      navigate('/login', { replace: true });
    }
  }

  return (
    <main className="min-h-full flex flex-col px-4 pb-6">
      <PageHeader title="Settings" icon={SettingsIcon} />

      {user && (
        <section className="mb-card mb-6">
          <p className="text-caption text-gray-500">Signed in as</p>
          <p className="text-body font-medium text-gray-900">{user.name}</p>
          <p className="text-small text-gray-500">{user.email}</p>
          <p className="text-caption text-gray-500 mt-1">Role: {user.role}</p>
        </section>
      )}

      <BigButton
        type="button"
        onClick={onLogout}
        loading={loading}
        variant="danger"
        size="lg"
      >
        <LogOut className="h-5 w-5" aria-hidden="true" />
        {loading ? 'Signing out…' : 'Sign out & forget this device'}
      </BigButton>

      <p className="mt-3 text-caption text-gray-500 text-center">
        Revokes the 30-day device trust on the server. Next sign-in on this
        device will require your TOTP code again.
      </p>
    </main>
  );
}
